import React from 'react';
import { GoogleLogin, GoogleLogout, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import FcGoogle from 'react-icons/fc';
import shareVideo from '../assets/share.mp4'
import logo from '../assets/logowhite.png'
import jwtDecode from 'jwt-decode';
import {client} from '../client'

const Login = () => {
  const navigate = useNavigate();
  const responseMessage = (response) => {
    const decode = jwtDecode(response.credential)
    localStorage.setItem('user',JSON.stringify(decode))
    const {name, aud, picture} = decode
    const doc = {
      _id: aud,
      _type: 'user',
      userName: name,
      image: picture
    }
    client.createIfNotExists(doc)
    .then(()=>{
      navigate('/', {replace: true})
    })
    
  };
  const errorMessage = (error) => {
    console.log(error);
  };

  return (
    <div className='flex justify-start items-center flex-col h-screen'>
      <div className='relative w-full h-full'>
        <video
          src={shareVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className='w-full h-full object-cover'
          />
        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay">
        <div className='p-5'>
            <img src={logo} width="130px" alt='logo'/>
        </div>
        <div className='shadow-2x1'>
            <GoogleLogin
            className="bg-mainColor flex justify-center items-center p-3 rounded-large cursor-pointer outline-none"
            onSuccess={responseMessage}
            onError={errorMessage}
            />
        </div>
        </div>
      </div>
    </div>
  )
}

export default Login;